module.exports = __webpack_public_path__ + "static/crypto_nft_mobile_app_cover-7a9121060514d9e91312aad31aaec89a.png";